import { render, staticRenderFns } from "./AlertFormModal.vue?vue&type=template&id=38c5227e"
import script from "./AlertFormModal.vue?vue&type=script&lang=js"
export * from "./AlertFormModal.vue?vue&type=script&lang=js"
import style0 from "./AlertFormModal.vue?vue&type=style&index=0&id=38c5227e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports